import { API_RESOURCE } from '@/constants/api.constant'
import useAction from '@/hooks/useAction'
import { useCrud } from '@/hooks/useCrud'
import { createOptions } from '@/utils/arrayHelper'
import { keepPreviousData, useMutation, useQueryClient } from '@tanstack/react-query'
import service from './vendor.service'

const useVendor = () => {
  const baseCrud = useCrud(API_RESOURCE.VENDOR)

  const queryClient = useQueryClient()

  const useVendorOptions = ({ key = 'name', status = 'active' }) => {
    return useQueryErrorResetBoundary({
      queryKey: [...baseCrud.queryKey.list({ page: 1, pageSize: 0, filters: { status: status } })],
      queryFn: () => service.fetchAll({ page: 1, pageSize: 0, filters: { status: status } }),
      placeholderData: keepPreviousData,
      select: (data) => createOptions(data?.data, 'name', key),
    })
  }

  const useRegisterTempVendor = useAction({ mutationFn: service.registerTempVendor, queryKey: baseCrud.queryKey })

  return {
    //Base CRUD
    // useFetchAllVendors: baseCrud.useFetchAll,
    // useFetchVendor: baseCrud.useFetchOne,
    // useCreateVendor: baseCrud.useCreate,
    // useUpdateVendor: baseCrud.useUpdate,
    // useRemoveVendor: baseCrud.useRemove,

    //Extra
    useVendorOptions,
    useRegisterTempVendor,
  }
}

export default useVendor
